module.exports = __webpack_public_path__ + "static/src/content/images/processed/800/thurston_promo.5e75849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/800/thurston_promo.jpg
// module id = Euv8
// module chunks = 1